/**
 * 用户注册
 */
export async function requestRegister(
  data: RegisterReq
): Promise<Res<RegisterRes>> {
  return http.post('/v1/auth/register', data)
}
